module.exports = __webpack_public_path__ + "static/img/areaA_9.561039e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/areaA_9.png
// module id = 982
// module chunks = 1